export default __webpack_public_path__ + "static/media/landigCTA.4d70eab3.png";